import React, { useState } from 'react';

import { CanAccess, ITreeMenu, useNavigation } from '@pankod/refine-core';
import { AntdLayout, Menu, Grid, Icons, useMenu } from '@pankod/refine-antd';
import { antLayoutSider, antLayoutSiderMobile } from './styles';

const { UnorderedListOutlined } = Icons;

export const Sider: React.FC = () => {
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const { SubMenu } = Menu;

  const { menuItems, selectedKey, defaultOpenKeys } = useMenu();
  const { push } = useNavigation();
  const breakpoint = Grid.useBreakpoint();

  const isMobile = !breakpoint.lg;

  const renderTreeView = (tree: ITreeMenu[], selectedTreeKey: string) => {
    return tree.map((item: ITreeMenu) => {
      const { icon, label, route, name, children, parentName } = item;

      if (children.length > 0) {
        return (
          <CanAccess key={name} resource={children.map(c => c.name.toLowerCase()).join('|')} action="list">
            <SubMenu
              key={name}
              icon={icon ?? <UnorderedListOutlined />}
              title={label}>
              {renderTreeView(children, selectedTreeKey)}
            </SubMenu>
          </CanAccess>
        );
      }
      const isSelected = route === selectedTreeKey;
      const isRoute = !(parentName !== undefined && children.length === 0);
      return (
        <CanAccess key={route} resource={name.toLowerCase()} action="list">
          <Menu.Item
            key={selectedTreeKey}
            onClick={() => {
              push(route ?? '');
            }}
            icon={icon ?? (isRoute && <UnorderedListOutlined />)}>
            {label}
            {!collapsed && isSelected && (
              <div className="ant-menu-tree-arrow" />
            )}
          </Menu.Item>
        </CanAccess>
      );
    });
  };

  return (
    <AntdLayout.Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(collapsedFlag: boolean): void => setCollapsed(collapsedFlag)}
      collapsedWidth={isMobile ? 0 : 80}
      breakpoint="lg"
      style={isMobile ? antLayoutSiderMobile : antLayoutSider}>
      <Menu
        selectedKeys={[selectedKey]}
        defaultOpenKeys={defaultOpenKeys}
        mode="inline"
        onClick={({ key }) => {
          if (!breakpoint.lg) {
            setCollapsed(true);
          }

          push(key as string);
        }}>
        {renderTreeView(menuItems, selectedKey)}
      </Menu>
    </AntdLayout.Sider>
  );
};
